<template>
  <div class="row content">
    <div 
      class="summary well small col-md-12 ">
      <table class="col-md-12">
        <thead>
          <tr>
            <td>Total Invoiced Amount</td>
            <td>Line Items Total</td>
            <td>Balance</td>
            <td>Due</td>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <td>Total Invoiced Amount</td>
            <td>Line Items Total</td>
            <td>Balance</td>
            <td>Due</td>
          </tr>
        </tfoot>
        <tbody>
          <tr>
            <td>
              <v-money :currency="currency" name='intial_total_amount'>{{ model.InitialInvoiceAmount }}</v-money>
            </td>
            <td>
              <v-money :currencu="currency" name='current_invoiced_amount'>{{ model.CurrentInvoicedAmount }}</v-money>
            </td>
            <td>
               <v-money :currency="currency" name='budget_balance'>{{ balance }}</v-money>
            </td>
            <td>
              <span name='due'>{{ getTimeDue }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="clear" />
    </div>
  </div>
</template>

<script>
  /* eslint spec-file: 0 */
  import { EventBus } from '@/event-bus'
  import LineItemStore from './dialogs/LineItem/LineItemStore.js'
  import Events from '@/core/events/events'

  export default {
    props: {
      model: Object,
      sectionClass: String
    },

    data() {
      return {
        invoiceCurrency: this.model.InitialInvoiceCurrencyCode
      }
    },

    created() {
      EventBus.$off(Events.I2P.UPDATE_INVOICE_SCAN_SNAPSHOT)
      EventBus.$on(Events.I2P.UPDATE_INVOICE_SCAN_SNAPSHOT, this.updateSnapshot)
    },

    computed: {
      currency() {
        return this.invoiceCurrency
      },
      balance() {
        return this.model.InitialInvoiceAmount - this.model.CurrentInvoicedAmount
      },
      getTimeDue() {
        let now = new Date().getTime()
        let due = new Date(this.getDateFromAspNetFormat(this.model.DueTime)).getTime()
        var h = Math.floor(((due - now) % 86400000) / 3600000)
        var m = Math.round((((due - now) % 86400000) % 3600000) / 60000)
        return h > 0 ? h + ' hr ' + m + ' min' : 0 + ' hr'
      }
    },

    methods: {
      store() {
        return new LineItemStore(this.api)
      },

      updateSnapshot(e) {
        let sentCurrencyCode = e && e.data && e.data.invoiceCurrencyCode
        if (sentCurrencyCode) {
          this.invoiceCurrency = sentCurrencyCode
        }
        this.updateSnapshotItems(e.data.total)
      },

      updateSnapshotItems(total) {
        this.model.CurrentInvoicedAmount = total
        this.model.BudgetBalance = this.model.InitialInvoiceAmount - this.model.CurrentInvoicedAmount
      },

      getDateFromAspNetFormat(date) {
        const re = /-?\d+/
        const m = re.exec(date)
        return parseInt(m[0], 10)
      }
    }
  }

</script>

<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";
  @mixin soft-font {
    transform: rotate(.03deg); // soften font a bit
  }
  
  .snapshot {
    @include theme {
    }
    &.striped .field {
      &:nth-of-type(odd) {
        @include theme {
          background: v(canvas);
        }
      }
      &.field {
        border: none;
      }
    }
    .field {
      padding-left: 1em;
      padding-right: 1em;
      line-height: 1.5em;
      @include theme {
        border-top: 1px solid v(background);
      }
      &.header {
        @include theme {
          background: v(background-light);
        }
      }
      &.footer-line {
        @include theme {
          border-bottom: 1px solid v(background);
        }
      }
      &.field.footer {
        @include theme {
          background: v(ink);
        }
        .value {
          font-size: $font-size-base-lg;
        }
      }
      label {
        @include soft-font;
        font-size: $font-size-base-sm;
        text-transform: uppercase;
        margin: 0;
      }
      .value {
        @include soft-font;
        display: inline-block;
        font-size: $font-size-base-sm;
        float: right;
      }
    }
  }
  
  // Section cards or containers
  .summary {
    &.well {
      @include theme {
      background: v(canvas);
      border-color: v(background);
      }
      border-radius: 0;
      box-shadow: none;
      padding: .7em 1.5em;
    }
    thead, tfoot {
      font-size: $font-size-xsmall;
    }
    thead {
      display: none;
    }
    tfoot {
      @include theme {
      color: v(background);
      }
    }
    tbody {
      font-weight: $font-weight-bold;
      font-size: $font-size-base-lg;
    }
    td {
      &:first-child {
        padding-left: 0;
      }
      padding-left: 2.33333333%;
    }
  }
  .well {
    border-radius: 0;
    padding-top: .8em;
    padding-bottom: .6em;
    box-shadow: none;
    @include theme {
    border-color: v(background);
    }
    margin-bottom: 10px;

    .expand-icon {
      line-height: 1.7em;
    }

    label {
      @include soft-font;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/BudgetInvoiceScanSnapshot.vue